import { render, staticRenderFns } from "./DashboardParking.vue?vue&type=template&id=20f381a4&"
import script from "./DashboardParking.vue?vue&type=script&lang=js&"
export * from "./DashboardParking.vue?vue&type=script&lang=js&"
import style0 from "./DashboardParking.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports